import { wgs2gcj } from '@/util/map/proj'

export const toLatlng = (v) => {
  let d = wgs2gcj(v.longitude , v.latitude)
  return new AMap.LngLat(d[0],d[1])
}

export const distance = (a , b) => AMap.GeometryUtil.distance(a , b)

export const latlngFromObject = (v) => toLatlng(v)

export const isCircleInRing = (center , radius , paths = []) => AMap.GeometryUtil.isPointInRing(center , paths) && paths.every(i => AMap.GeometryUtil.distance(center , i) > radius )

var geocoderTool
export const geocoder = (position) => {
  if(!geocoderTool){
    if(AMap.Geocoder){
      geocoderTool = new AMap.Geocoder({
        radius: 500
      });
    }else{
      return Promise.reject()
    }
  }

  return new Promise((resolve , reject) => {
    geocoderTool.getAddress(position, (status, result) => {
      if (status === 'complete' && result.regeocode) {
        const g = result.regeocode.addressComponent
        // let address = `${g.province}${g.city}${g.district}${g.township}${g.street}${g.streetNumber}`
        let address = result.regeocode.formattedAddress
        resolve(address)
      }else{
        resolve('')
      }
    });
  })
}

var autoCompleteTool;
export const search = (key) => {
  if(!autoCompleteTool){
    if(AMap.Autocomplete){
      autoCompleteTool = new AMap.Autocomplete({
        city: '全国'
      });
    }else{
      return Promise.reject()
    }
  }

  return new Promise((resolve , reject)=>{
    autoCompleteTool.search(key, (status, result) => {
      // 搜索成功时，result即是对应的匹配数据
      resolve(result)
    })
  })
}